module.exports = __webpack_public_path__ + "img/big-circle.f746a58a.svg";